import type { ComponentChildren } from 'preact';
import { useEffect } from 'preact/hooks';
import { useI18n } from '../../i18n';
import { useProfile } from '../../state/profile';

/**
 * Gate for the authenticated web app (Play / Boards / Profile). Redirects to
 * login when signed out and to onboarding when signed in but not yet onboarded.
 * Mirrors RequireAdmin's hydration-aware pattern so we never flash a redirect.
 *
 * NOTE: the /onboarding route itself must NOT be wrapped in this guard or it
 * would redirect to itself in a loop.
 */
export function RequireOnboarded({ children }: { children: ComponentChildren }) {
  const { route } = useProfile();
  const { t, localePath } = useI18n();

  useEffect(() => {
    if (route === 'signed-out') {
      const ret = encodeURIComponent(location.pathname + location.search);
      location.replace(`${localePath('/login')}?return=${ret}`);
    } else if (route === 'full' || route === 'welcomeBack') {
      const ret = encodeURIComponent(location.pathname + location.search);
      location.replace(`${localePath('/onboarding')}?return=${ret}`);
    }
  }, [route]);

  if (route === 'ready') return <>{children}</>;

  return (
    <div class="bcapp">
      <div class="bc-spinner">{t('app.loading')}</div>
    </div>
  );
}
